function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import { BaseCardHeader, Icon, Badge } from '@unite-us/ui';
import { get } from 'lodash';
import { STATUSES } from '../../../common/constants';
import { getCountAnsweredAndQuestions } from '../../../common/utils';
import statusColor from '../../../common/utils/statusColor';
import { APP_FLAGS, CALLBACKS, CORE_HOOKS } from '../../../api/config';
function ScreeningMenuInfo(_ref) {
  var _personData$data;
  var isFetching = _ref.isFetching,
    screening = _ref.screening,
    editMode = _ref.editMode,
    handleOnEditClick = _ref.handleOnEditClick,
    subheaderText = _ref.title,
    personId = _ref.personId,
    allowEdit = _ref.allowEdit;
  var _useState = useState(0),
    _useState2 = _slicedToArray(_useState, 2),
    answered = _useState2[0],
    setAnswered = _useState2[1];
  var _useState3 = useState(0),
    _useState4 = _slicedToArray(_useState3, 2),
    questions = _useState4[0],
    setQuestions = _useState4[1];
  var calculateAnsweredAndQuestions = function calculateAnsweredAndQuestions(formSub) {
    var _getCountAnsweredAndQ = getCountAnsweredAndQuestions(formSub),
      questionCount = _getCountAnsweredAndQ.questionCount,
      answeredCount = _getCountAnsweredAndQ.answeredCount;
    setQuestions(questionCount);
    setAnswered(answeredCount);
  };
  useEffect(function () {
    if (!isFetching) {
      calculateAnsweredAndQuestions(screening);
    }
  }, [isFetching, screening]);
  var status = get(screening, 'status', 'Draft');
  // TODO: Check and format dates if the backend response has a different format
  // hardcoded date values, change when core returns this data
  var lastSavedDate = get(screening, 'updated_at', 'Jan 3, 2024');
  var completedDate = get(screening, 'status_at', 'Jan 5, 2024');
  var isFormCompleted = status.toLowerCase() === STATUSES.COMPLETE;
  var isFormDeclined = status.toLowerCase() === STATUSES.DECLINED;
  var _CORE_HOOKS$useFindRe = CORE_HOOKS.useFindRecord('person', personId, {
      queryConfig: {
        placeholderData: undefined
      }
    }),
    personData = _CORE_HOOKS$useFindRe.data;
  var person = personData === null || personData === void 0 || (_personData$data = personData.data) === null || _personData$data === void 0 ? void 0 : _personData$data.data;
  var EditButton = /*#__PURE__*/React.createElement("div", {
    id: "assessment-edit-btn",
    onClick: handleOnEditClick,
    role: "button",
    onKeyDown: handleOnEditClick,
    tabIndex: 0
  }, /*#__PURE__*/React.createElement(Icon, {
    icon: "IconPencil",
    style: {
      svg: {
        width: '1em',
        height: '1em'
      }
    }
  }), /*#__PURE__*/React.createElement("p", {
    className: "assessment-edit-btn__text"
  }, "Edit"));
  var hbh1509ClientsDrawerEnabled = APP_FLAGS.hbh1509ClientsDrawerEnabled;
  var showClientDrawer = hbh1509ClientsDrawerEnabled;
  var onContactNameClick = CALLBACKS.onContactNameClick;
  var title = /*#__PURE__*/React.createElement("div", {
    className: "assessment-details-view__header"
  }, person && subheaderText && /*#__PURE__*/React.createElement("span", {
    className: "text-xl font-bold mb-2",
    "aria-label": "".concat(subheaderText, " for ").concat(person.full_name)
  }, "".concat(subheaderText, " for "), showClientDrawer ? /*#__PURE__*/React.createElement("a", {
    href: "#",
    className: "mb-2 text-action-blue hover:underline",
    onClick: onContactNameClick(person)
  }, person.full_name) : person.full_name), /*#__PURE__*/React.createElement("div", {
    className: "flex flex-col items-start"
  }, /*#__PURE__*/React.createElement("span", null, get(screening, 'form.name', ''))), /*#__PURE__*/React.createElement("div", {
    className: "mt-2 flex justify-between items-center"
  }, /*#__PURE__*/React.createElement("div", {
    className: "flex items-center"
  }, /*#__PURE__*/React.createElement(Badge, {
    text: status,
    style: {
      padding: '4px',
      height: 20,
      minWidth: 52,
      fontSize: 12,
      textTransform: 'capitalize',
      backgroundColor: statusColor(status),
      borderRadius: 12
    }
  }), isFormCompleted ? /*#__PURE__*/React.createElement("div", {
    className: "italic ml-4 font-normal text-xs"
  }, "Completed on ".concat(new Intl.DateTimeFormat('en-US', {
    month: 'long',
    day: '2-digit',
    year: 'numeric'
  }).format(new Date(completedDate)))) : /*#__PURE__*/React.createElement("div", {
    className: "italic ml-4 font-normal text-xs"
  }, "Saved ".concat(new Intl.DateTimeFormat('en-US', {
    month: 'long',
    day: '2-digit',
    year: 'numeric'
  }).format(new Date(lastSavedDate)))))));
  return /*#__PURE__*/React.createElement(BaseCardHeader, {
    title: title
  }, /*#__PURE__*/React.createElement("div", {
    className: "flex flex-col items-end"
  }, !isFormCompleted && !editMode && !isFormDeclined && allowEdit && /*#__PURE__*/React.createElement("div", {
    className: "mb-4"
  }, EditButton), /*#__PURE__*/React.createElement("div", {
    className: "font-medium text-sm"
  }, "".concat(answered, "/").concat(questions, " Answered"))));
}
ScreeningMenuInfo.propTypes = {
  formSubmission: PropTypes.object.isRequired,
  isFetching: PropTypes.bool,
  allowEdit: PropTypes.bool,
  editMode: PropTypes.bool,
  handleOnEditClick: PropTypes.func.isRequired,
  title: PropTypes.string,
  personId: PropTypes.string
};
ScreeningMenuInfo.defaultProps = {
  isFetching: true,
  allowEdit: true,
  editMode: false,
  personId: null
};
export default ScreeningMenuInfo;
//# sourceMappingURL=ScreeningMenuInfo.js.map